"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const zod_1 = require("zod");
const manifest_1 = require("../manifest");
const _appearance_1 = require("./_appearance");
/**
 * Advertisement (SP5b / Phase 2) — plays an existing advertising *playlist*
 * (built in the platform-app Advertising module) as a storefront slideshow, so
 * the same creative doesn't have to be rebuilt here. `playlistId` is chosen with
 * the `playlist-id` control (fed by the tenant's playlists).
 */
(0, manifest_1.registerSection)({
    type: 'advertisement', label: 'Advertisement', icon: 'megaphone', category: 'content',
    settingsSchema: zod_1.z.object({
        playlistId: zod_1.z.string().default(''),
        autoplay: zod_1.z.boolean().default(true),
        interval: zod_1.z.number().int().min(2).max(30).default(5),
        showDots: zod_1.z.boolean().default(true),
        ..._appearance_1.appearanceShape,
    }),
    defaults: () => ({ playlistId: '', autoplay: true, interval: 5, showDots: true, ...(0, _appearance_1.appearanceDefaults)() }),
    fields: [
        { name: 'playlistId', label: 'Advertising playlist', control: 'playlist-id', group: 'Content' },
        { name: 'autoplay', label: 'Autoplay', control: 'toggle', group: 'Content' },
        { name: 'interval', label: 'Seconds per slide', control: 'number', min: 2, max: 30, group: 'Content' },
        { name: 'showDots', label: 'Show dots', control: 'toggle', group: 'Content' },
        ..._appearance_1.appearanceFields,
    ],
});
//# sourceMappingURL=advertisement.js.map